import "./styles.scss";

import moment from "moment";
import { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

// import Checkbox from "../../Checkbox";
import Select from "../../Checkout/Select";
import Inputs from "../../Checkout/Inputs";
import { getCountries, postAffiliateTax } from "../../../store/middleware";

function ModalTaxInformation({ showModal, setShowModal }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const [success, setSuccess] = useState(false);
  const [countries, setCountries] = useState([]);
  const [form, setForm] = useState({
    city: "",
    state: "",
    taxId: "",
    zipcode: "",
    address1: "",
    fullname: "",
    address2: "",
    birthDate: "",
    taxIdType: "",
    personType: "PF",
    whereLiveCountryId: "",
    //taxClassification: "",
    citizenshipCountryId: "",
  });

  const allTaxIdType = [
    { id: "SSN", name: "SSN (US Residents)" },
    { id: "CPF", name: "CPF (Brasil)" },
    { id: "RFC", name: "RFC (México)" },
    { id: "NIT", name: "NIT (Colombia)" },
    { id: "other", name: t("OTHER") },
  ];

  const closeModal = () => {
    setShowModal(false);
    setSuccess(false);
  };

  const handleChange = (e) => {
    const { value, name, type, checked } = e.target;
    const valueFormatted = type === "checkbox" ? checked : value;

    setForm((state) => ({ ...state, [name]: valueFormatted }));

    if (name === "taxIdType") {
      if (value === "SSN") setForm((state) => ({ ...state, whereLiveCountryId: "212" }));
      else if (value === "CPF") setForm((state) => ({ ...state, whereLiveCountryId: "26" }));
      else if (value === "RFC") setForm((state) => ({ ...state, whereLiveCountryId: "122" }));
      else if (value === "NIT") setForm((state) => ({ ...state, whereLiveCountryId: "40" }));
      else if (value === "other") setForm((state) => ({ ...state, whereLiveCountryId: "" }));
    }
  };

  const validateForms = () => {
    if (!form.fullname) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("NAME_FULL") }));
      return false;
    } else if (!form.birthDate || moment(form.birthDate).isAfter(moment().subtract(1, "year"))) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("BIRTH_DATE") }));
      return false;
    } else if (!form.taxIdType) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("FISCAL_DOCUMENT") }));
      return false;
    } else if (!form.taxId) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: "Tax ID" }));
      return false;
    } else if (!form.address1) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("ADDRESS").concat(" 01") }));
      return false;
    } else if (!form.city) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("CITY") }));
      return false;
    } else if (!form.state) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("STATE") }));
      return false;
    } else if (!form.zipcode) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("ZIPCODE") }));
      return false;
    } else if (!form.citizenshipCountryId) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("CITIZENSHIP_COUNTRY") }));
      return false;
    } else if (!form.whereLiveCountryId) {
      alert(t("FIELD_IS_REQUIRED", { fieldName: t("WHERE_LIVE_COUNTRY") }));
      return false;
    } else return true;
  };

  const handleSave = () => {
    if (validateForms()) {
      dispatch(postAffiliateTax({ ...form, affiliateId: affiliateInfo?.id, userId: affiliateInfo?.userId }))
        .then((resp) => resp && setSuccess(true))
        .catch((resp) => console.log(resp));
    }
  };

  useEffect(() => {
    dispatch(getCountries()).then((res) => setCountries(res));
    // eslint-disable-next-line
  }, []);

  return (
    <Dialog
      open={showModal}
      onClose={closeModal}
      className="modalPrivilege"
      classes={"modalTaxInformation"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="containerTaxInformation">
        <h3 className="title">{t("TAX_INFORMATION")}</h3>

        {!success ? (
          <form className="contentTaxInformation">
            {/* <div className="wrapperTypePerson">
            <Checkbox
              label={t("PHYSICAL_PERSON")}
              checked={form.personType === "PF"}
              onChange={() => setForm((state) => ({ ...state, personType: "PF" }))}
            />
            <Checkbox
              label={t("LEGAL_PERSON")}
              checked={form.personType === "PJ"}
              onChange={() => setForm((state) => ({ ...state, personType: "PJ" }))}
            />
          </div> */}

            {/* <Inputs
            type="text"
            onChange={handleChange}
            name="taxClassification"
            style={{ marginBottom: 35 }}
            value={form.taxClassification}
            label={t(form.personType === "PJ" ? "CORPORATE_NAME" : "NAME_FULL")}
          /> */}

            <div className="row">
              <Inputs
                type="text"
                name="fullname"
                value={form.fullname}
                label={t("NAME_FULL")}
                onChange={handleChange}
                style={{ marginBottom: 35 }}
              />

              <Inputs
                type="date"
                name="birthDate"
                value={form.birthDate}
                label={t("BIRTH_DATE")}
                onChange={handleChange}
                style={{ marginBottom: 35 }}
              />
            </div>

            <div className="wrapperDocument">
              <Select
                width="108"
                name="taxIdType"
                options={allTaxIdType}
                onChange={handleChange}
                labelSelect={t("SELECT")}
                label={t("FISCAL_DOCUMENT")}
              />

              <Inputs
                type="text"
                name="taxId"
                value={form.taxId}
                onChange={handleChange}
                placeholder={
                  form.taxIdType === "SSN" ? "xxx-xx-xxxx" : form.taxIdType === "CPF" ? "xxx.xxx.xxx-xx" : ""
                }
              />
            </div>

            <Inputs
              type="text"
              name="address1"
              value={form.address1}
              onChange={handleChange}
              style={{ marginBottom: 35 }}
              label={
                t(
                  form.taxIdType === "SSN"
                    ? "AMERICAN_ADDRESS"
                    : form.taxIdType === "CPF"
                    ? "BRAZILIAN_ADDRESS"
                    : form.taxIdType === "RFC"
                    ? "ADRESSE_MEXICAINE"
                    : form.taxIdType === "NIT"
                    ? "ADRESSE_COLOMBIENNE"
                    : "ADDRESS",
                ) + " 01"
              }
            />

            <Inputs
              type="text"
              name="address2"
              value={form.address2}
              onChange={handleChange}
              style={{ marginBottom: 35 }}
              label={
                t(
                  form.taxIdType === "SSN"
                    ? "AMERICAN_ADDRESS"
                    : form.taxIdType === "CPF"
                    ? "BRAZILIAN_ADDRESS"
                    : form.taxIdType === "RFC"
                    ? "ADRESSE_MEXICAINE"
                    : form.taxIdType === "NIT"
                    ? "ADRESSE_COLOMBIENNE"
                    : "ADDRESS",
                ) + " 02"
              }
            />

            <div className="row">
              <Inputs
                type="text"
                name="city"
                label={t("CITY")}
                value={form.city}
                onChange={handleChange}
                style={{ marginBottom: 35 }}
              />

              <Inputs
                type="text"
                name="state"
                label={t("STATE")}
                value={form.state}
                onChange={handleChange}
                style={{ marginBottom: 35 }}
              />

              <Inputs
                type="text"
                name="zipcode"
                label={t("ZIPCODE")}
                value={form.zipcode}
                onChange={handleChange}
                style={{ marginBottom: 35 }}
              />
            </div>

            <div className="wrapperSelect">
              <Select
                options={countries}
                onChange={handleChange}
                labelSelect={t("SELECT")}
                name="citizenshipCountryId"
                label={t("CITIZENSHIP_COUNTRY")}
              />
              <Select
                options={countries}
                onChange={handleChange}
                name="whereLiveCountryId"
                labelSelect={t("SELECT")}
                value={form.whereLiveCountryId}
                label={t("WHERE_LIVE_COUNTRY")}
                disabled={form.taxIdType === "other" ? false : true}
              />
            </div>

            {form.taxIdType === "SSN" && <p className="alertTaxInformation">{t("ALERT_TAX_INFORMATION")}</p>}
          </form>
        ) : (
          <h4 className="textAlign">{t("SUCCESS_MESSAGE_TAX_INFORMATION")}</h4>
        )}

        <div className="footer">
          {!success ? (
            <>
              <button className="buttonModalBack" onClick={closeModal}>
                {t("BACK")}
              </button>
              <button className="buttonModalSave" onClick={handleSave}>
                {t("SAVE")}
              </button>
            </>
          ) : (
            <button className="buttonModalSave" onClick={closeModal}>
              {t("BTN_CLOSE")}
            </button>
          )}
        </div>
      </div>
    </Dialog>
  );
}

export default ModalTaxInformation;
